{
  "badges": {
    "u23": "Under 23 (U23)",
    "u25": "Under 25 (U25)",
    "auction": "Active auction",
    "listed": "Listed on the transfer market",
    "ai": "AI team",
    "incoming": "Incoming transfer",
    "outgoing": "Outgoing transfer",
    "self": "Internal trade (own team)",
    "bought": "You bought this rider",
    "sold": "You sold this rider",
    "injured": "Injured",
    "academy": "Academy rider (off the senior squad cap)",
    "retireRisk": "High retirement risk: riders typically retire between ages 36 and 40",
    "contractExpiring": "Contract expires at the next season change: this rider becomes a free agent unless the contract is extended first",
    "junior": "Junior rider (on your junior squad)",
    "label": {
      "u23": "U23",
      "u25": "U25",
      "auction": "AUC",
      "ai": "AI",
      "incoming": "IN",
      "outgoing": "OUT",
      "self": "OWN",
      "bought": "BUY",
      "sold": "SOLD",
      "injured": "INJ",
      "academy": "ACAD",
      "retireRisk": "35+",
      "contractExpiring": "EXP",
      "listed": "LIST",
      "junior": "JR"
    }
  },
  "page": {
    "back": "Back",
    "notFound": "Rider not found",
    "retry": "Try again",
    "loadingAria": "Loading rider"
  },
  "header": {
    "watchlistAdd": "Add to watchlist",
    "watchlistRemove": "Remove from watchlist",
    "watchlistToggleFailed": "Could not update your watchlist. Please try again.",
    "compare": "⇄ Compare",
    "compareTitle": "Compare with other riders",
    "watchlistCount": "👁 {count, plural, one {1 manager follows this rider} other {# managers follow this rider}}",
    "visitors": "👀 {count, plural, one {1 unique visitor} other {# unique visitors}} (7d)",
    "visitors24h": "{count, plural, one {1 in the last 24h} other {# in the last 24h}}",
    "visitorsNew": "New",
    "visitorsTrendUp": "Up {pct}% vs the previous 7 days",
    "visitorsTrendDown": "Down {pct}% vs the previous 7 days",
    "u23": "U23",
    "junior": "Junior",
    "u25": "U25",
    "retired": "Retired",
    "ageYears": "{age} yrs",
    "heightCm": "{height} cm",
    "weightKg": "{weight} kg",
    "potential": "Potential",
    "overall": "Rating",
    "teamPrefix": "Team:",
    "freeAgent": "Free agent",
    "nextSeasonPrefix": "Incoming:",
    "pendingTransfer": "Joining {team} once his current stage race finishes",
    "activeAuctionBadge": "⚡ Active auction",
    "highestBidLabel": "Highest bid: {amount} CZ$",
    "valueLabel": "Value CZ$",
    "contractSalary": "Salary CZ$",
    "contractLength": "{count, plural, one {1 season} other {# seasons}}",
    "contractExpires": "Expires after season {season}",
    "noContract": "Free agent (no contract)",
    "estSalary": "Est. salary CZ$",
    "typeDefault": "All-rounder",
    "newValueBeta": "New value (beta): {amount} CZ$",
    "newValueBetaTooltip": "Preview of the upcoming ability-based valuation. Not yet used for buying, selling or salary."
  },
  "blocked": {
    "pendingTransfer": "🔒 The rider has been traded and joins his new team once his current stage race finishes. He cannot be traded again until then.",
    "retired": "The rider is retired and cannot be traded.",
    "errorFallback": "Something went wrong"
  },
  "offerShortcut": {
    "textWithPrice": "Open offer: {price} CZ$ from {team}",
    "text": "Open offer from {team}",
    "unknownTeam": "another manager",
    "cta": "Decide"
  },
  "tabs": {
    "stats": "Skills",
    "season": "Season history",
    "results": "Race results",
    "bids": "Bid history",
    "history": "History",
    "development": "Development"
  },
  "profile": {
    "training": {
      "title": "Training focus",
      "slotsUsed": "{used} / {total} slots used",
      "loading": "Loading training…",
      "focus": {
        "vo2max": "VO2max",
        "vo2max_climb": "VO2max (climbing)",
        "vo2max_punch": "VO2max (punch)",
        "threshold": "Threshold",
        "sprint": "Sprint",
        "endurance": "Endurance",
        "technique": "Technique",
        "aero": "Aero",
        "tempo": "Tempo",
        "restitution": "Active recovery",
        "loebslaere": "Race craft",
        "cobbled_sectors": "Cobbled Sectors",
        "echelon_drills": "Echelon Drills",
        "attack_repeats": "Attack Repeats",
        "long_climbs": "Long climbs",
        "lead_out": "Lead-out",
        "itt_short": "Short time trials",
        "itt_long": "Long time trials",
        "cobbled_classic": "Cobbled classic"
      },
      "active": "Active: {focus} · {intensity} · trains {abilities}",
      "activeRest": "Resting ({focus} focus paused)",
      "effectNote": "updates daily",
      "noRiskNote": "Higher intensity grows faster, with no risk of losing progress.",
      "restNote": "No ability growth on a rest day; fatigue recovers.",
      "emptyFocus": "Pick a focus to assign training.",
      "actionErrorGeneric": "Could not save. Try again in a moment.",
      "actionErrors": {
        "no_slots": "No training slots left.",
        "auth": "Your session expired. Sign in again.",
        "network": "Connection failed. Check your network and try again."
      },
      "log": {
        "title": "Daily training · last 7 days",
        "empty": "No training days yet.",
        "today": "Today",
        "sharp": "Sharp day",
        "flat": "Flat day",
        "gains": "+{count} abilities"
      },
      "trend": {
        "title": "Training · last 30 days",
        "trained": "Sessions trained",
        "breakthroughs": "Breakthroughs",
        "sharp": "Sharp days",
        "note": "Counted from the last 30 days of training runs."
      },
      "form": {
        "title": "Form & recovery",
        "healthy": "Injury-free",
        "healthyHint": "Ready to train hard",
        "pending": "No condition data yet."
      },
      "locked": {
        "title": "Training is hidden",
        "body": "You can't see or manage another team's rider training, form or fatigue. Sign him and it unlocks."
      },
      "retired": {
        "title": "Retired rider",
        "body": "Retired riders aren't trained, so there's no active program, form or fatigue to show."
      },
      "changeFocus": "Change",
      "chooseFocus": "Choose",
      "score": {
        "title": "Training score",
        "todayLabel": "Today's session",
        "race": "Race",
        "raceNote": "Race day: the race replaces training",
        "sparkAria": "Training score, last 7 days",
        "avg": "Average, {days} days",
        "best": "Best, 30 days",
        "driverUp": "{driver} +{points}",
        "driverDown": "{driver} −{points}"
      }
    },
    "tabs": {
      "overview": "Overview",
      "physiology": "Physiology",
      "training": "Training",
      "development": "Development",
      "scouting": "Scouting",
      "history": "History",
      "results": "Results",
      "palmares": "Palmarès",
      "interest": "Interest"
    },
    "switcher": {
      "hint": "Arrow keys switch rider"
    },
    "hero": {
      "bestRoleEyebrow": "Best role now",
      "divisionChip": "DIV {division}",
      "photoFallback": "Photo",
      "potentialOwn": "Projected level",
      "potentialScouted": "Scouted projection",
      "valueEyebrow": "Market value",
      "popularityEyebrow": "Popularity",
      "reputationEyebrow": "Reputation",
      "salary": "Salary",
      "contract": "Contract",
      "contractSeason": "Season {season}",
      "contractExpired": "Expired",
      "contractExpiredSub": "Free agent at the season change unless extended",
      "contractExpires": "expires",
      "aiTag": "AI",
      "ratingTrendRising": "Rising this season",
      "ratingTrendSteady": "Steady this season",
      "ratingTrendDeclining": "Declining this season",
      "ratingTrendTitle": "Rating {value} since {date}"
    },
    "reputation": {
      "whyTitle": "Why his reputation moved",
      "progressTo": "{value} / {target} to {band}",
      "weighting": "Wins and big races count most",
      "help": "How reputation works",
      "close": "Close",
      "noEvents": "No reputation events yet.",
      "unknownRace": "A race",
      "band": {
        "unknown": "Unknown",
        "known": "Known",
        "profile": "Profile",
        "star": "Star",
        "legend": "Legend"
      },
      "events": {
        "one_day_win": "One-day win",
        "one_day_podium": "One-day podium",
        "one_day_top10": "One-day top 10",
        "gc_win": "GC win",
        "gc_podium": "GC podium",
        "gc_top10": "GC top 10",
        "stage_win": "Stage win",
        "stage_podium": "Stage podium",
        "stage_top10": "Stage top 10",
        "jersey_points_win": "Points jersey",
        "jersey_mountain_win": "Mountain jersey",
        "jersey_young_win": "Young rider jersey",
        "leader_day": "Leader's jersey",
        "fallback": "Reputation event"
      }
    },
    "levelCorrectionReceipt": {
      "developmentLine": "Development: no change from training this week.",
      "marketLine": "Market: one-time level adjustment, all riders. Values now match what riders actually trade for. Your rider is not getting worse.",
      "detailsToggle": "Show numbers",
      "detailsHide": "Hide numbers",
      "anchorBefore": "Value before",
      "anchorAfter": "Value after",
      "factor": "Correction factor",
      "appliedAt": "Applied {date}"
    },
    "banner": {
      "listed": "On the transfer list · price {price}",
      "auction": "In auction · ends in {endsIn} · highest bid {highBid}",
      "finalSeasonTitle": "Final season",
      "finalSeason": "Announced his retirement at the season start. He retires when season {season} ends."
    },
    "history": {
      "loading": "Loading history...",
      "chipBid": "Bid",
      "bidBy": "placed a bid",
      "table": {
        "date": "Date",
        "type": "Type",
        "event": "Event",
        "amount": "Amount"
      },
      "loadError": "Trade history could not be loaded right now."
    },
    "results": {
      "totalsTitle": "Season totals",
      "filterLabel": "Season filter",
      "filterAll": "All",
      "totals": {
        "wins": "Wins",
        "races": "Races",
        "top5": "Top 5",
        "jerseys": "Jerseys",
        "points": "Ranking points",
        "prize": "Prize money"
      },
      "table": {
        "date": "Date",
        "race": "Race",
        "class": "Class",
        "terrain": "Terrain",
        "pos": "Pos.",
        "points": "Points",
        "prize": "Prize"
      },
      "terrain": {
        "flat_sprint": "Flat",
        "long_sprint_classic": "Rolling",
        "cobbled_classic": "Cobbles",
        "gravel_classic": "Gravel",
        "puncheur": "Hilly",
        "hilly_classic": "Hilly",
        "mountain_classic": "Mountain",
        "itt_classic": "Time trial"
      },
      "stagesCount": "{n} stages",
      "stageRow": "Stage {n}",
      "overallRow": "Overall (GC)",
      "expandHint": "Tap the chevron to unfold all stages; tap the race name to open it.",
      "emptySeason": "No results in this season.",
      "seasonShort": "S{n}",
      "loadError": "Results could not be loaded right now."
    },
    "palmares": {
      "careerFirstsTitle": "Career firsts",
      "trophyTitle": "Trophy case",
      "trophy": {
        "gcWins": "GC wins",
        "oneDayWins": "One-day wins",
        "stageWins": "Stage wins",
        "jerseyWins": "Final jerseys",
        "jerseyDays": "Days in jersey",
        "podiums": "Podiums"
      },
      "jerseyDayLine": {
        "leader": "Leader jersey · {n, plural, one {# day} other {# days}}",
        "points_day": "Points jersey · {n, plural, one {# day} other {# days}}",
        "mountain_day": "Mountains jersey · {n, plural, one {# day} other {# days}}",
        "young_day": "Young rider jersey · {n, plural, one {# day} other {# days}}"
      },
      "totalsTitle": "Career totals",
      "totals": {
        "races": "Races",
        "winRate": "Win rate",
        "points": "Ranking points",
        "prize": "Prize money"
      },
      "seasonHonoursTitle": "Season by season",
      "teamFallback": "Unknown team",
      "achievement": {
        "gcWin": "Winner (GC)",
        "raceWin": "Winner",
        "podium2": "2nd place",
        "podium3": "3rd place",
        "stageWin": "Stage {n} winner",
        "jersey": {
          "points": "Points classification",
          "mountain": "Mountains classification",
          "young": "Young rider classification"
        }
      },
      "emptyTitle": "No palmarès yet",
      "emptyBody": "Every career starts blank. The first result writes the opening line.",
      "loadError": "Palmarès could not be loaded right now."
    },
    "scouting": {
      "loading": "Loading scouting report...",
      "loadFailed": "The scouting report could not be loaded. Try again in a moment.",
      "eyebrowOwn": "Your scout's verdict",
      "eyebrowOther": "Scouting report",
      "provenanceNamed": "Assessed by {name} · Tier {tier} scout",
      "provenanceDefault": "Assessed by your team's default scout (rating {overall})",
      "recalcNote": "The band shows where he's realistically heading with your training. It reflects your CURRENT scout's precision and is recalculated whenever your scout changes, but the rider's actual abilities are never affected. A better scout narrows the range, but it isn't a guarantee: the true value can occasionally sit just outside it.",
      "notScoutedTitle": "Not scouted",
      "notScoutedBody": "You don't know this rider's potential yet. Use a scout slot to get your scout's first read on him.",
      "potentialLabel": "Potential",
      "headline_keep_and_develop": "Keep & develop",
      "headline_bid_worth_considering": "A bid worth considering",
      "headline_monitor": "Keep an eye on him",
      "headline_solid_contributor": "Solid contributor",
      "headline_past_peak": "Past his peak",
      "confidence_high": "Fully scouted",
      "confidence_medium": "Partly scouted",
      "confidence_low": "Barely scouted",
      "confidenceTitle_high": "You have learned everything your scout can tell you about this rider. How narrow the band is still depends on your scout's rating, not on this.",
      "confidenceTitle_medium": "Your scout has reported more than once, but not everything he can. Scout again to complete the read.",
      "confidenceTitle_low": "A first read only. Scout again before you act on it.",
      "verdictIsRead": "This is your scout's read, not a fact. It is built on his projected level, so another manager's scout can reach a different conclusion about the same rider.",
      "verdictTextNoLoft": "With the right training I see him landing at {progLo}-{progHi}, but it takes dedicated focus all the way.",
      "factor_age_upside": "Young enough to have seasons of growth ahead",
      "factor_ceiling_gap": "Clear gap between today's level and where he's projected to land",
      "factor_near_ceiling": "Already close to his projected level, little left to gain",
      "factor_decline_risk": "At an age where decline sets in",
      "factor_type_match": "The verdict weighs his best rider type most",
      "factor_form_unknown": "Form and fatigue are not visible to scouts",
      "factor_watch_races": "Race results will confirm or challenge this read",
      "rescoutHint": "Scout him again to sharpen the estimate. A low-rated scout reaches his own precision limit before the last level.",
      "typesTitle": "Projection per rider type",
      "primaryProgressionLabel": "Projected",
      "typesSubtitleNoLoft": "potential sets the pace",
      "naturalRolesLabel": "His natural roles",
      "otherRolesNaturalLabel": "Other roles",
      "otherRolesNote": "Roles share abilities. The order here is an estimate.",
      "typesLegendNoLoft": "Solid bar = level today. Shaded band = where he's realistically heading with your training: the bottom is steady but unfocused work, the top is dedicated focus every day. Potential decides how fast he gets there. It is an estimate, not a guarantee, and no scout knows a rider exactly. Ratings are comparable across roles - the same number means the same level everywhere.",
      "precisionNext": "The next scout level narrows the band from ±{half} to ±{next} points.",
      "precisionUseless": "Another level would not visibly narrow the band for your current chief scout (±{half} points). A better chief scout would.",
      "precisionAtMax": "This is as narrow as scouting gets him. The band's width now rests on your chief scout's rating (±{half} points).",
      "capsMissingTitle": "Report incomplete",
      "capsMissingBody": "Projection data is not available for this rider yet, so the per-type outlook can't be shown.",
      "scoutFailed": "Could not send the scout. Try again in a moment.",
      "scoutErrors": {
        "max_level": "This rider is already fully scouted.",
        "capacity": "Your scout is already fully booked. Wait for a job to finish.",
        "insufficient_funds": "Not enough CZ$ to send a scout.",
        "insufficient_available_balance": "Not enough available money: part of your balance is locked in auction bids.",
        "auth": "Your session expired. Sign in again.",
        "network": "Connection failed. Check your network and try again."
      }
    },
    "interest": {
      "loading": "Loading interest...",
      "loadError": "Interest data could not be loaded right now.",
      "trendFlat": "stable",
      "seasonShort": "S{n}",
      "stats": {
        "followers": "Followers",
        "views7d": "Profile views (7d)",
        "scoutedBy": "Scouted by"
      },
      "followersSub": "{count, plural, one {manager} other {managers}}",
      "scoutedBySub": "{count, plural, one {rival team} other {rival teams}}",
      "scoutedBySubNeutral": "{count, plural, one {team} other {teams}}",
      "selfBadge": "incl. you",
      "summary": {
        "own": "{followers, plural, =0 {No managers follow him yet} one {1 manager follows him} other {# managers follow him}} · scouted by {scouted, plural, =0 {no rivals} one {1 rival team} other {# rival teams}} · {views, plural, =0 {no unique visitors} one {1 unique visitor} other {# unique visitors}} in the last 7 days.",
        "ownQuiet": "No one has shown interest yet. He stays under the radar for now.",
        "scouting": "{followers, plural, =0 {No managers follow him yet} one {1 manager follows him} other {# managers follow him}} · scouted by {scouted, plural, =0 {no one} one {1 team} other {# teams}} · {views, plural, =0 {no unique visitors} one {1 unique visitor} other {# unique visitors}} in the last 7 days.",
        "scoutingQuiet": "No visible interest yet."
      },
      "whoScouts": {
        "title": "Who is scouting your rider?",
        "body": "{count, plural, one {1 rival team has used scout slots on him.} other {# rival teams have used scout slots on him.}}",
        "empty": "No rivals have scouted him yet.",
        "level": "Level {level}"
      },
      "feed": {
        "title": "Activity",
        "scout": "{team} scouted him",
        "scoutAnon": "A rival scouted him",
        "scoutSelf": "You scouted him",
        "watch": "Added to a manager's watchlist",
        "watchSelf": "You added him to your watchlist",
        "viewsTrend": "Profile views {pct}% vs the previous 7 days",
        "viewsTrendMeta": "last 7 days",
        "empty": "No activity yet"
      }
    },
    "overview": {
      "skillCount": "{count} abilities",
      "radar": {
        "title": "Rider types",
        "subtitle": "rating per type",
        "legendNow": "Now",
        "allTypes": "All types",
        "notARanking": "Roles are built from different abilities, so these numbers are not a ranking of what he should be."
      },
      "physio": {
        "title": "Physiology",
        "weight": "{kg} kg",
        "link": "Power curve & zones"
      }
    },
    "development": {
      "empty": "No recorded development yet. The curve builds as the rider trains and seasons pass.",
      "loading": "Loading development...",
      "chart": {
        "title": "Rating by type · over seasons",
        "caption": "recorded development · daily snapshots",
        "season": "S{n}",
        "seasonNow": "S{n} now"
      },
      "growth": {
        "title": "Growth this season",
        "typeRating": "{type} rating",
        "thisSeason": "{delta} this season",
        "abilityPoints": "Ability points gained",
        "trackedSince": "Tracked since"
      },
      "reading": {
        "title": "Reading",
        "own": {
          "rising": "He has gained {delta} in {type} rating this season. Training is paying off.",
          "flat": "No measured gain yet this season. The curve builds as he trains."
        },
        "scouting": {
          "rising": "Rising curve this season. Training plans are hidden for rival riders.",
          "flat": "Flat curve so far this season. Training plans are hidden for rival riders."
        }
      },
      "log": {
        "title": "Development log",
        "hint": "training → ability gains per season",
        "seasonNow": "Season {n} · now",
        "delta": "{delta} rating",
        "note": "gains on {days} of the last {window} days",
        "noTraining": "no training recorded",
        "scoutingHidden": "The training-driven development log is hidden for rival riders. You only see the recorded trend above."
      },
      "projection": {
        "legend": "projection",
        "caption": "solid = recorded · dashed = projection · shaded = target range",
        "now": "now",
        "ceilingLabel": "TARGET",
        "toCeiling": "To target",
        "ageAtCeiling": "Target age",
        "seasonsRange": "~{lo}–{hi} seasons",
        "seasonsOpen": "~{lo}+ seasons",
        "seasonsSingle": "~{n} seasons",
        "ageRange": "~{lo}–{hi}",
        "ageOpen": "~{lo}+",
        "ageSingle": "~{n}",
        "atCeiling": "At target now",
        "outlook": "Outlook",
        "approaching": "Approaching target",
        "gapToCeiling": "Long gap to target",
        "pastPeak": "Past peak, declining"
      }
    },
    "physio": {
      "pending": "Physiology not yet available",
      "over": "over",
      "under": "under",
      "divMean": "Div mean {value}",
      "divMeanShort": "vs Div {division}",
      "head": {
        "ftp": "FTP",
        "ftpSub": "Threshold (~1 hour) · {wkg} W/kg",
        "vo2": "VO₂max",
        "vo2Sub": "Aerobic ceiling (W/kg)",
        "pmax": "Pmax",
        "pmaxSub": "Peak sprint power",
        "zone2": "Zone 2",
        "zone2Sub": "Endurance base"
      },
      "curve": {
        "title": "Power curve",
        "subtitle": "Max power per duration · log scale",
        "hisZone": "HIS ZONE",
        "rider": "Rider"
      },
      "profile": {
        "title": "Power profile",
        "note": {
          "sprint": "Sprint top",
          "anaerobic": "Anaerobic",
          "vo2": "VO₂",
          "thresholdPlus": "Threshold+",
          "threshold": "Threshold",
          "hour": "1 hour"
        }
      },
      "cp": {
        "title": "Critical Power model",
        "cp": "CP (critical power)",
        "wprime": "W′ anaerobic capacity",
        "read": "W′ is the anaerobic reserve above CP: the work you can spend before fading; CP is the power you can hold almost indefinitely."
      },
      "zones": {
        "title": "Power zones",
        "derived": "Derived from FTP {ftp} W (Coggan zones)",
        "name": {
          "Z1": "Active recovery",
          "Z2": "Endurance",
          "Z3": "Tempo",
          "Z4": "Threshold",
          "Z5": "VO₂max",
          "Z6": "Anaerobic",
          "Z7": "Neuromuscular"
        }
      }
    }
  },
  "terrain": {
    "flatSprint": "Flat bunch sprints",
    "rolling": "Rolling roads",
    "punchy": "Punchy finishes",
    "mountain": "Mountain stages",
    "stageRace": "Stage races",
    "timeTrial": "Time trials",
    "breakaway": "Breakaways",
    "cobbles": "Cobbles"
  },
  "stats": {
    "potentialRow": "Potential",
    "abilitiesPending": "Abilities not yet available",
    "categories": {
      "physical": "Physical",
      "mental": "Mental",
      "technical": "Technical"
    }
  },
  "racePreview": {
    "title": "Cycling Zones",
    "beta": "Beta",
    "disclaimer": "New physiological model, calculated from current skills. Does not affect race results yet.",
    "powerProfile": "Power profile",
    "derivedAbilities": "Derived abilities",
    "zones": {
      "ftp": "FTP",
      "vo2max": "VO2max power",
      "zone2": "Zone 2",
      "pmax": "Peak power"
    },
    "curve": {
      "p5s": "5s",
      "p15s": "15s",
      "p1m": "1 min",
      "p5m": "5 min"
    },
    "derived": {
      "climbing": "Climbing",
      "time_trial": "Time trial",
      "prolog": "Prologue",
      "flat": "Flat",
      "tempo": "Tempo",
      "sprint": "Sprint",
      "acceleration": "Acceleration",
      "punch": "Punch",
      "endurance": "Endurance",
      "recovery": "Recovery",
      "durability": "Durability",
      "descending": "Descending",
      "cobblestone": "Cobbles",
      "positioning": "Positioning",
      "aggression": "Aggression",
      "tactics": "Tactics",
      "teamwork": "Teamwork",
      "leadership": "Leadership"
    }
  },
  "skills": {
    "fl": {
      "short": "FL",
      "long": "Flat"
    },
    "bj": {
      "short": "BJ",
      "long": "Mountain"
    },
    "kb": {
      "short": "KB",
      "long": "Mid-mountain"
    },
    "bk": {
      "short": "BAK",
      "long": "Hill"
    },
    "tt": {
      "short": "TT",
      "long": "Time trial"
    },
    "prl": {
      "short": "PRL",
      "long": "Prologue"
    },
    "bro": {
      "short": "BRO",
      "long": "Cobbles"
    },
    "sp": {
      "short": "SP",
      "long": "Sprint"
    },
    "acc": {
      "short": "ACC",
      "long": "Acceleration"
    },
    "ned": {
      "short": "NED",
      "long": "Descent"
    },
    "udh": {
      "short": "UDH",
      "long": "Endurance"
    },
    "mod": {
      "short": "MOD",
      "long": "Resilience"
    },
    "res": {
      "short": "RES",
      "long": "Recovery"
    },
    "ftr": {
      "short": "FTR",
      "long": "Fighter"
    }
  },
  "season": {
    "row": "Season {n}"
  },
  "results": {
    "empty": "No race results yet",
    "fallbackDash": "-"
  },
  "bids": {
    "row": {
      "teamFallback": "Unknown",
      "autoBidTag": "Auto-bid"
    }
  },
  "history": {
    "empty": "No trade history yet",
    "fallbackDash": "-",
    "auction": {
      "labelAi": "AI sale",
      "labelGuaranteed": "Guaranteed sale",
      "labelDefault": "Auction",
      "wonBy": "won from",
      "buyerFallback": "Unknown",
      "buyerFallbackAi": "AI team",
      "sellerFallbackAi": "AI team",
      "sellerFallback": "Unknown"
    },
    "transfer": {
      "label": "Transfer",
      "buys": "buys from",
      "buyerFallback": "Unknown",
      "sellerFallback": "Unknown"
    },
    "swap": {
      "label": "Swap",
      "teamFallback": "Unknown",
      "cashAdjustment": "Cash adjustment: {amount} CZ$"
    }
  },
  "auctionPanel": {
    "activeLabel": "⚡ Active auction",
    "badges": {
      "leading": "You're leading",
      "selling": "You're selling",
      "outbid": "You've been outbid",
      "extended": "⚡ Ext",
      "flash": "⚡ Flash"
    },
    "highestBid": "Highest bid",
    "leaderFallback": "",
    "timeLeft": "Time left",
    "sellerPrefix": "Seller: {name}",
    "cannotBidOwn": "You're selling this auction. Cannot bid on your own rider.",
    "fallbackDash": "-",
    "bidInputAria": "Your bid in CZ$",
    "bidPlace": "Bid",
    "bidRaise": "Raise",
    "bidError": "Error",
    "bidPlaceAria": "Place bid",
    "bidRaiseAria": "Raise your bid",
    "minBid": "Min. bid: {amount} CZ$",
    "errorFallback": "The bid could not be placed",
    "proxyErrorFallback": "Failed to set auto-bid",
    "proxyRemoveErrorFallback": "The auto-bid limit could not be removed. It is still active.",
    "proxy": {
      "display": "Auto-bid: max {amount} CZ$",
      "edit": "Change",
      "editAria": "Change auto-bid limit",
      "remove": "Remove",
      "removeAria": "Remove auto-bid",
      "addAria": "Set auto-bid limit",
      "addButton": "+ Set auto-bid limit",
      "inputPlaceholder": "Max limit",
      "inputAria": "Auto-bid limit in CZ$",
      "save": "Save",
      "saveAria": "Save auto-bid limit",
      "cancelAria": "Cancel auto-bid editing",
      "error": "Error",
      "saved": "✓"
    },
    "riderNameFallback": "rider"
  },
  "countdown": {
    "completed": "Completed",
    "expired": "Expired",
    "hoursMinutes": "{h}h {m}m",
    "minutesSeconds": "{m}m {s}s",
    "seconds": "{s}s"
  },
  "auctionStart": {
    "label": {
      "myRider": "Put up for auction",
      "bank": "Start auction (AI rider)",
      "ai": "Start auction (AI rider)",
      "free": "Start auction (free agent)"
    },
    "flash": {
      "label": "⚡ Flash auction (30 min)",
      "hint": "Deadline Day: ends exactly 30 minutes after start"
    },
    "end": {
      "label": "Auction ends",
      "hint": "{min}-{max} hours from now, game time (Copenhagen).",
      "windowHint": "The market is open {open}-{close}."
    },
    "buttons": {
      "start": "Start auction",
      "startFlash": "⚡ Start Flash auction",
      "loading": "..."
    },
    "priceError": "Start price must at least match Value ({amount} CZ$)",
    "priceErrorOwn": "Start price must be between 0 and Value ({amount} CZ$)",
    "squadWarning": "Auction started.\n\nNote: you are now running auctions equal to {total} riders (max {max}). The cap is a hard limit, so you cannot win more riders than your squad can hold."
  },
  "directOffer": {
    "buttonOpen": "Send transfer offer",
    "amountPlaceholder": "Offer amount in CZ$",
    "messagePlaceholder": "Message (optional)",
    "submit": "Send offer",
    "sending": "Sending...",
    "toast": {
      "success": "✅ Offer sent!",
      "errorPrefix": "❌"
    }
  },
  "sellRider": {
    "buttonOpen": "List for sale",
    "description": "List the rider for sale at a fixed price on the transfer list. You can edit the price or remove the listing at any time.",
    "pricePlaceholder": "Asking price in CZ$",
    "submit": "List for sale",
    "submitUpdate": "Update price",
    "sending": "Saving...",
    "listedStatus": "On the transfer list for {amount} CZ$",
    "editPrice": "Edit price",
    "hideEdit": "Hide",
    "remove": "Remove from list",
    "confirmRemove": "Yes, remove",
    "cancel": "Cancel",
    "toast": {
      "listed": "✅ Listed for sale!",
      "priceUpdated": "✅ Asking price updated",
      "removed": "✅ Removed from the transfer list",
      "errorPrefix": "❌"
    }
  },
  "manage": {
    "extend": {
      "button": "Extend contract",
      "description": "Extend this rider's contract by one season at a renegotiated salary.",
      "currentSalary": "Current salary",
      "newSalary": "New salary",
      "newSalaryHint": "Follows what he's delivering this season. Current salary stays fixed until you renew.",
      "newContract": "New contract",
      "newContractValue": "Through season {season}",
      "confirm": "Confirm extension",
      "loadingTerms": "Loading terms…",
      "working": "Extending…",
      "success": "Contract extended.",
      "errorPrefix": "Couldn't extend:",
      "capped": "Contract at maximum length (through season {season})."
    },
    "release": {
      "button": "Release rider",
      "description": "End this rider's contract. They leave your squad and become a free agent.",
      "fee": "Buyout fee",
      "balance": "Your balance",
      "feeHint": "The buyout fee is half the salary left on the contract.",
      "freeHint": "This rider is out of contract, so there's no buyout fee.",
      "cannotAfford": "You can't afford the buyout fee.",
      "confirm": "Release rider",
      "loadingTerms": "Loading terms…",
      "working": "Releasing…",
      "cancel": "Cancel",
      "success": "Rider released.",
      "errorPrefix": "Couldn't release:"
    },
    "move": {
      "button": "Move squad",
      "success": {
        "senior": "Rider moved to your senior squad.",
        "u23": "Rider moved to your U23 team.",
        "junior": "Rider moved to your junior team."
      }
    }
  },
  "swapOffer": {
    "buttonOpen": "⇄ Propose swap",
    "selectRider": "Select rider to offer",
    "cashLabel": "Cash payment (CZ$)",
    "cashHint": "Positive: you pay. Negative: you receive.",
    "submit": "Send swap",
    "sending": "Sending...",
    "toast": {
      "success": "✅ Swap proposed!",
      "errorPrefix": "❌"
    }
  },
  "celebration": {
    "title": "You won the auction! 🏆",
    "subtitle": "The rider is now on your team"
  },
  "compare": {
    "title": "Compare Riders",
    "subtitle": "Add up to 3 riders to compare stats",
    "searchPlaceholder": "Search rider to add...",
    "searching": "Searching...",
    "teamFree": "Free agent",
    "empty": "Search for a rider above to start comparing",
    "potential": "Potential",
    "loadingAria": "Loading comparison",
    "loadErrorTitle": "Couldn't load comparison",
    "loadErrorBody": "Nothing was lost. Try again.",
    "retry": "Try again"
  },
  "scouting": {
    "label_worldclass": "World-class prospect",
    "label_high": "High projection",
    "label_solid": "Solid prospect",
    "label_rotation": "Squad rotation",
    "scout": "Scout",
    "rescout": "Scout again",
    "scouting": "Scouting…",
    "scoutTitle": "Send your scout to sharpen this rider's potential estimate. How much sharper it gets depends on your scout's rating",
    "noSlots": "No scout slots left this season",
    "scoutBusy": "Scout busy, free in {minutes, plural, one {1 min} other {# min}}",
    "scoutBusyNow": "Scout busy, free any moment",
    "levelUseless": "Your chief scout has reached his own precision limit: another level would not narrow the estimate",
    "levelTitle": "Scouting level. Higher is more precise, up to your own scout's precision limit",
    "potentialBandTitle": "Projected level as {role}: {lo}-{hi}.",
    "potentialBandSubtitle": "Where he realistically lands with your training. Always a range, no scout knows a rider exactly.",
    "loftShort": "ceiling {value}",
    "loftTitle": "Role ceiling: up to {value}. Every {role} shares the same ceiling, potential decides how fast he climbs toward it.",
    "loftPastPeakShort": "ceiling {value} · past peak",
    "loftPastPeakTitle": "The role's craft ceiling is {value}. He's past his peak and no longer developing toward it - the forecast shows where he actually lands.",
    "notScouted": "Not scouted",
    "scoutToReveal": "Potential is hidden until you scout this rider",
    "pendingTitle": "Your scout is already working on this rider",
    "pendingShort": "Report in ~{minutes} min",
    "pendingShortCountdown": "Report in {minutes, plural, one {1 min} other {# min}}",
    "pendingShortDue": "Report ready",
    "pendingJob": "Scout working, report in ~{minutes} min",
    "pendingJobCountdown": "Scout working, report in {minutes, plural, one {1 min} other {# min}}",
    "pendingJobDue": "Report ready. Refresh to open it.",
    "pendingReadyAtTitle": "Report ready at {time} Danish time",
    "sendScoutJob": "Send scout (~{minutes} min, {cost, number})"
  },
  "condition": {
    "form": "Form",
    "fatigue": "Fatigue",
    "injured": "Injured: {days}d left",
    "injuredRaceDays": "Injured: {days, plural, one {1 race day} other {# race days}} left",
    "fitAgain": "Fit again {date}",
    "fitAgainApprox": "Fit again approx. {date}",
    "causeCrashStage": "Crashed, {race} stage {stage}",
    "causeCrashRace": "Crashed, {race}",
    "causeCrash": "Crashed in a race",
    "causeTraining": "Injured in training",
    "causeIllness": "Ill"
  },
  "training": {
    "title": "Training focus",
    "intro": "Set a season-long training focus for this key rider. It nudges the trained abilities faster toward their target.",
    "gatedNote": "Training shapes permanent ability and applies at the next season change.",
    "slotsLeft": "{remaining}/{total} focus slots",
    "focus": "Focus",
    "intensity": "Intensity",
    "focus_vo2max": "VO2max (mixed intervals)",
    "focus_vo2max_climb": "VO2max (climbing intervals)",
    "focus_vo2max_punch": "VO2max (punch intervals)",
    "focus_threshold": "Threshold / TT",
    "focus_sprint": "Sprint",
    "focus_tempo": "Tempo",
    "focus_endurance": "Endurance (Zone 2)",
    "focus_technique": "Technique",
    "focus_aero": "Aero",
    "focus_loebslaere": "Race craft",
    "focus_restitution": "Active recovery",
    "focus_cobbled_sectors": "Cobbled Sectors",
    "focus_echelon_drills": "Echelon Drills",
    "focus_attack_repeats": "Attack Repeats",
    "focus_long_climbs": "Long climbs",
    "focus_lead_out": "Lead-out",
    "focus_itt_short": "Short time trials",
    "focus_itt_long": "Long time trials",
    "focus_cobbled_classic": "Cobbled classic",
    "intensity_rest": "Rest",
    "intensity_unknown_pending": "Awaiting race review",
    "intensity_easy": "Easy",
    "intensity_normal": "Normal",
    "intensity_hard": "Hard",
    "set": "Set focus",
    "update": "Update focus",
    "remove": "Remove",
    "saving": "Saving…",
    "noSlots": "No focus slots left this season",
    "current": "Current focus",
    "assistantNoRisk": "Faster targeted growth, no setback risk.",
    "assistantRisk": "Faster targeted growth, but ~{risk}% risk of a setback (lost gains) this season.",
    "tradeoff": "Other abilities grow a little slower.",
    "intensity_recovery": "Recovery"
  }
}
